/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Jérôme Poulalier.
 *
 * Jérôme Poulalier can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file App.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {
    Router
} from 'starting-blocks'
import Nav from './common/Nav'
import TransitionFactory from './factories/TransitionFactory'
import ClassFactory from './factories/ClassFactory'
import bubbleSketch from './sketchs/BubbleSketch'
import RZScroll from './scroll/ScrollManager'
import $ from 'jquery'
import * as Utils from './utils/Utils'

export default class App {
    constructor () {
        /**
         * @type {Scene|null}
         */
        this.router = null
        this.nav = null
        this.smoothScrolls = []
        this.trash = []

        // Elements
        /**
         * @type {jQuery|HTMLElement}
         */
        this.$window = $(window)

        // Binded methods
        this.onTransitionStart = this.onTransitionStart.bind(this)
        this.onTransitionComplete = this.onTransitionComplete.bind(this)
        this.onInitScroll = this.onInitScroll.bind(this)
        this.onScrollTo = this.onScrollTo.bind(this)
        this.onScrollToPercent = this.onScrollToPercent.bind(this)
        this.onScrollDestroy = this.onScrollDestroy.bind(this)
        this.onScrollUpdateElements = this.onScrollUpdateElements.bind(this)
        this.onLazyImageLoad = this.onLazyImageLoad.bind(this)
    }

    init () {
        // Add global listeners
        window.addEventListener('SB_TRANSITION_START', this.onTransitionStart)
        window.addEventListener('SB_TRANSITION_COMPLETE', this.onTransitionComplete)
        window.addEventListener('scroll.destroy', this.onScrollDestroy)
        window.addEventListener('scroll.init', this.onInitScroll)
        this.$window.on('scroll.updateElements', this.onScrollUpdateElements)
        this.$window.on('scroll.scrollTo', this.onScrollTo)
        this.$window.on('scroll.scrollToPercent', this.onScrollToPercent)
        this.$window.on('LazyImageLoad', this.onLazyImageLoad)

        // New Router instance
        this.router = new Router({
            useCache: true,
            ajaxEnabled: true,
            lazyloadEnabled: true,
            classFactory: new ClassFactory(),
            transitionFactory: new TransitionFactory()
        })

        // New Nav instance
        this.nav = new Nav(this.router)

        // Init bubble scene p5
        new window.p5(bubbleSketch)

        // Init everything
        this.nav.init()
        this.router.init()

        this.initSmoothScroll()
    }

    initSmoothScroll () {
        if (this.router.page) {
            const scrollElements = this.router.page.$cont.find('.js-scroll')
            let count = 0
            for (let scrollElement of scrollElements) {
                let detectTouch = false
                count++

                if (count === 1 && scrollElements.length > 1) {
                    detectTouch = true
                }

                const smoothScroll = new RZScroll({
                    container: $(scrollElement),
                    selector: '.js-animate',
                    smooth: true,
                    smoothMobile: true,
                    mobileContainer: $(scrollElement),
                    getWay: false,
                    detectTouch,
                    getSpeed: false
                })

                smoothScroll.init()

                this.smoothScrolls.push(smoothScroll)
            }

            if (this.router.page.scrollInitiated) {
                this.router.page.scrollInitiated()
            }
        }
    }

    onLazyImageLoad () {
        for (let smoothScroll of this.smoothScrolls) {
            smoothScroll.instance.updateElements()
        }
    }

    onScrollUpdateElements () {
        for (let smoothScroll of this.smoothScrolls) {
            smoothScroll.instance.updateElements()
        }
    }

    onScrollToPercent (e, data) {
        if (this.smoothScrolls.length > 0) {
            if (data && data.percentY) {
                const y = (data.percentY / 100) * (this.smoothScrolls[data.index].instance.scrollbarLimit - window.innerHeight)
                this.smoothScrolls[data.index].scrollTo(0, y, 1)
            }
        }
    }

    onScrollTo (e, data) {
        if (data && data.positions && this.smoothScrolls[0]) {
            const { x, y, duration } = data.positions
            this.smoothScrolls[0].scrollTo(x, y, duration)
        }
    }

    onTransitionStart () {
        this.addToTrash()
    }

    addToTrash () {
        for (let [cpt, smoothScroll] of this.smoothScrolls.entries()) {
            this.trash.push(smoothScroll)
            this.smoothScrolls.splice(cpt, 0)
        }

        this.smoothScrolls = []
    }

    clearTrash () {
        for (let smoothScroll of this.trash) {
            smoothScroll.destroy(smoothScroll.options.container)
        }

        this.trash = []
    }

    onTransitionComplete () {

    }

    onScrollDestroy () {
        this.addToTrash()
        this.clearTrash()
    }

    onInitScroll () {
        this.initSmoothScroll()
    }
}



// WEBPACK FOOTER //
// ./webpack/js/App.js